import React, { useEffect, useRef, useState } from "react";
import "./membership.css";
import htmlToPdfmake from 'html-to-pdfmake';
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import MembershipCardHtmlComponent from "./membership.card.html.component";
import { useLocation } from "react-router-dom";
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';


// Assign the fonts directly
// pdfMake.vfs = {
//   ...pdfMake.vfs || {},
//   ...pdfFonts
// };
const MembershipFormComponent = () => {

  const [successMessage, setSuccessMessage] = useState("");

  const location = useLocation();  
  useEffect(() => {
    if (location.state?.successMessage) {
      setSuccessMessage(location.state.successMessage);
      console.log("Success Message Set:", location.state.successMessage); 
      setTimeout(() => setSuccessMessage(""), 3000);
    }
  }, [location.state?.successMessage]);

  const membershipRef = useRef(null);

  const [isGeneratingPdf, setIsGeneratingPdf] = useState(false);
  // const handlePrintPdf = () => {
  //   if (!membershipRef.current) {
  //     console.error("Membership card reference not found");
  //     return;
  //   }
  
  //   setIsGeneratingPdf(true);
    
  //   try {
  //     const membershipHtml = membershipRef.current.innerHTML;
  //     const pdfContent = htmlToPdfmake(membershipHtml);
      


  //     const docDefinition = {
  //       info: {
  //         title: "Membership Card",
  //       },
  //       pageSize: "A4",
  //       pageOrientation: "portrait",
  //       pageMargins: [40, 40, 40, 40],
  //       content: pdfContent,
  //       defaultStyle: {
  //         font: 'Roboto'
  //       },
        
  //       fonts: {
  //         Roboto: {
  //           normal: 'Roboto-Regular.ttf',
  //           bold: 'Roboto-Medium.ttf',
  //           italics: 'Roboto-Italic.ttf',
  //           bolditalics: 'Roboto-MediumItalic.ttf'
  //         }
  //       }
  //     };
  
  //     pdfMake.createPdf(docDefinition).download("SMART_Membership_Card.pdf");
  //   } catch (error) {
  //     console.error("Error generating PDF:", error);
  //   } finally {
  //     setIsGeneratingPdf(false);
  //   }
  // };
  const handlePrintPdf = async () => {
    if (!membershipRef.current) {
      console.error("Membership card reference not found");
      return;
    }
  
    setIsGeneratingPdf(true);
  
    try {
      // 1. Store original styles
      const originalStyles = {
        width: membershipRef.current.style.width,
        overflow: membershipRef.current.style.overflow,
        padding: membershipRef.current.style.padding,
        margin: membershipRef.current.style.margin
      };
      
      // 2. Prepare HTML for printing - remove all spacing
      // membershipRef.current.style.width = '794px';
      membershipRef.current.style.overflow = 'hidden';
      membershipRef.current.style.padding = '0';
      membershipRef.current.style.margin = '0';
  
      // 3. Create canvas - use device pixel ratio for better quality
      const devicePixelRatio = window.devicePixelRatio || 1;
      const canvas = await html2canvas(membershipRef.current, {
        scale: devicePixelRatio * 2, // Dynamic high resolution
        logging: false,
        useCORS: true,
        scrollX: 0,
        scrollY: 0,
        windowWidth: membershipRef.current.scrollWidth,
        windowHeight: membershipRef.current.scrollHeight,
        backgroundColor: null // Transparent background
      });
  
      // 4. Restore original styles
      Object.assign(membershipRef.current.style, originalStyles);
  
      // 5. Create PDF with truly minimal margins
      const pdf = new jsPDF({
        unit: 'pt',
        format: 'a4',
        hotfixes: ['px_scaling'] // Fix PDF.js px scaling issues
      });
  
      const imgData = canvas.toDataURL('image/png', 1.0);
      

      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();
      
      // Calculate scaling to use maximum space
      const imgWidth = canvas.width;
      const imgHeight = canvas.height;
      
      // Use 99% of page size (true minimal margin)
      const targetWidth = pageWidth * 0.99;
      const targetHeight = pageHeight * 0.99;
      
      const ratio = Math.min(
        targetWidth / imgWidth,
        targetHeight / imgHeight
      );
      
      // Center the content with true minimal margins
      const x = (pageWidth - (imgWidth * ratio)) / 2;
      const y = (pageHeight - (imgHeight * ratio)) / 2;
      
      pdf.addImage({
        imageData: imgData,
        format: 'PNG',
        x: x,
        y: y,
        width: imgWidth * ratio,
        height: imgHeight * ratio,
        compression: 'FAST' // Balance quality and size
      });
      
      pdf.save('SMART_Membership_Card.pdf');
      
    } catch (error) {
      console.error("Error generating PDF:", error);
    } finally {
      setIsGeneratingPdf(false);
    }
  };


  return (
    <div className="subscription-wrap">
      <main>
        <div className="subscription-title">
          <h1>Membership Card</h1>
          <p>
    To download your membership card, please{' '}
    <span 
      onClick={handlePrintPdf} 
      style={{
        color: '#3770d1',
        textDecoration: 'underline',
        cursor: 'pointer',
        fontWeight: 'bold'
      }}
    >
      click here
    </span>
    {isGeneratingPdf && <span> (generating...)</span>}
  </p>
        </div>

        <div>
         {successMessage && <div className="alert alert-success">{successMessage}</div>}
        </div>

        <div className="membership-html-container" ref={membershipRef}>
          <MembershipCardHtmlComponent />
        </div>
      </main>
      <br/>
      <br />
    </div>
  );
};

export default MembershipFormComponent;
